export class AddRecommendationItemControlAction {
    static controlButtonDisabled() {
      let target: any = document.getElementById("js-add-recommendation-item-button");
      target.removeAttribute("disabled");
      target.classList.remove("is-disabled");
    }

    static accordion(targetSuffix: string) {
      let targetElm: any = document.getElementById("js-add-recommendation-item-accordion-" + targetSuffix);
      let btnElm: any = document.getElementById("js-accordion-" + targetSuffix + "-button");
      let accordionElm: any = document.getElementById("js-accordion-target-" + targetSuffix);
      var isOpen: boolean = false;
      targetElm.classList.forEach((e) => {if (e == "is-open") isOpen = true });
      if (isOpen) {
        targetElm.classList.remove("is-open");
        btnElm.setAttribute("aria-expanded", "false");
        accordionElm.classList.add("is-open");
        accordionElm.style.display = "none";
      } else {
        targetElm.classList.add("is-open");
        btnElm.setAttribute("aria-expanded", "true");
        accordionElm.classList.remove("is-open");
        accordionElm.style.display = "block";
      }
    }

    static departmentAccordion() {
      this.accordion("department");
    }

    static companyAccordion() {
      this.accordion("company");
    }
}
